import { openDB } from 'idb';

const DB_NAME = 'jobcard_offline_db';
const SYNC_QUEUE_STORE = 'sync_queue';
const OFFLINE_DATA_STORE = 'offline_data';

interface SyncQueueItem {
    id: string;
    url: string;
    method: string;
    payload: any;
    timestamp: number;
}

const dbPromise = openDB(DB_NAME, 1, {
    upgrade(db) {
        // Store for sync queue
        db.createObjectStore(SYNC_QUEUE_STORE, { keyPath: 'id' });
        // Store for offline data
        db.createObjectStore(OFFLINE_DATA_STORE, { keyPath: 'id' });
    },
});

export async function queueAction(url: string, method: string, payload: any) {
    const db = await dbPromise;
    const id = `${Date.now()}-${Math.random()}`;
    const syncItem: SyncQueueItem = {
        id,
        url,
        method,
        payload,
        timestamp: Date.now(),
    };
    await db.add(SYNC_QUEUE_STORE, syncItem);
    return id;
}

export async function storeOfflineData(key: string, data: any) {
    const db = await dbPromise;
    await db.put(OFFLINE_DATA_STORE, { id: key, data });
}

export async function getOfflineData(key: string) {
    const db = await dbPromise;
    const item = await db.get(OFFLINE_DATA_STORE, key);
    return item?.data;
}

export async function processSyncQueue() {
    const db = await dbPromise;
    const tx = db.transaction(SYNC_QUEUE_STORE, 'readwrite');
    const store = tx.objectStore(SYNC_QUEUE_STORE);
    const items = await store.getAll();

    for (const item of items) {
        try {
            const response = await fetch(item.url, {
                method: item.method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(item.payload),
            });

            if (response.ok) {
                await store.delete(item.id);
            }
        } catch (error) {
            console.error('Failed to sync item:', error);
        }
    }
}

// Listen for online status
if (typeof window !== 'undefined') {
    window.addEventListener('online', () => {
        processSyncQueue();
    });
} 